module.exports = __webpack_public_path__ + "static/media/laundry.f2694b6c.svg";